var _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 165C136.399 165 165.5 135.899 165.5 100C165.5 64.1015 136.399 35 100.5 35C64.6015 35 35.5 64.1015 35.5 100C35.5 135.899 64.6015 165 100.5 165Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.86 158.053C133.066 158.053 157.553 133.566 157.553 103.36C157.553 73.1538 133.066 48.6667 102.86 48.6667C72.6538 48.6667 48.1667 73.1538 48.1667 103.36C48.1667 133.566 72.6538 158.053 102.86 158.053Z",
    fill: "#AEAEAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1933 151.387C127.4 151.387 151.887 126.9 151.887 96.6934C151.887 66.4871 127.4 42 97.1933 42C66.987 42 42.5 66.4871 42.5 96.6934C42.5 126.9 66.987 151.387 97.1933 151.387Z",
    fill: "white",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96.6667,
    cy: 97.1667,
    r: 47.5,
    fill: "#ECEEF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3532 48.2134C75.1398 46.9201 75.0532 53.3466 76.2732 53.7599C77.4932 54.1666 83.0399 55.1467 84.7532 55.8801C86.4665 56.6134 89.1532 63.1334 91.2732 63.5467C93.3932 63.9534 100.32 62.3267 101.547 63.5467C102.767 64.7667 106.44 67.8667 106.44 72.0267C106.44 76.1867 96.2465 88.2533 93.3932 89.96C90.5398 91.6733 83.6132 87.76 81.1665 90.12C78.7199 92.4866 84.2665 105.933 78.2332 105.933C72.1998 105.933 71.2199 100.96 68.4532 98.5933C65.6799 96.2266 61.4398 92.4 61.9332 88.8133C62.4198 85.2267 66.4999 70.7933 64.8665 69.2466C63.2332 67.6999 56.7799 62.7067 58.3732 58.68C58.3732 58.68 67.6332 50.4001 72.3532 48.2134Z",
    fill: "#36A635",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.653 149.147C113.753 148.513 113.286 142.093 113.693 139.367C114.1 136.64 118.993 135.293 119.32 129.58C119.646 123.873 117.773 121.02 115.246 117.353C112.72 113.687 102.686 110.927 98.6131 111.16C95.7598 111.32 90.2998 114.093 88.3398 115.727C86.3865 117.36 81.8998 118.827 82.3064 124.207C82.7131 129.587 92.4998 132.033 94.5331 135.293C96.5731 138.553 96.8198 149.14 98.1198 151.387C98.1198 151.387 104.8 151.22 111.653 149.153V149.147Z",
    fill: "#36A635",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2399 139.033C65.4732 140.94 62.9932 129.573 63.7266 125.5C64.4599 121.427 62.5866 118.16 59.3266 113.6C56.0666 109.033 47.5466 110.013 44.1599 108.38C44.1599 108.38 46.9399 125.1 63.2399 139.033Z",
    fill: "#36A635",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.96 111.14C149.22 115.187 145.08 105.12 143.447 103.493C141.813 101.86 136.927 104.713 133.667 102.68C130.407 100.64 132.033 94.12 129.913 90.94C127.793 87.76 125.513 88.4134 125.513 80.1801C125.513 71.9467 135.707 67.2201 139.7 62.7335C139.7 62.7335 156.287 76.5134 149.96 111.147V111.14Z",
    fill: "#36A635",
    stroke: "#4D4D4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/World.fa0d20f8431dc4656c85fda5926d6f97.svg";
export { ForwardRef as ReactComponent };